import React, { Component } from "react";
import ListErrorPrompt from "../../../../../../components/ListErrorPrompt";
import "./style.css";
class SchoolCharter extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const { visible, data } = this.props;
    return (
      <div
        className="schoolCharter_box"
        style={{
          display: visible === true ? "block" : "none",
          fontSize: "12px",
        }}
      >
        {data.schoolCharter === null || data.schoolCharter === "" ? (
          <ListErrorPrompt
            toptext="尚未集中公布，可以尝试通过右侧联系方式"
            bottomtext="进入招生办网址查看"
          ></ListErrorPrompt>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: data.schoolCharter }}></div>
        )}
      </div>
    );
  }
}

export default SchoolCharter;



// WEBPACK FOOTER //
// ./src/components/School/SchoolDetail/SchoolDetailDown/components/SchoolCharter/index.js